import { PickupEventEditPage } from "components/shared/pickupEvents";

const WPSCheckinEventsEditPage = () => (
  <PickupEventEditPage variant="wps" />
);

export default WPSCheckinEventsEditPage;
